export default {
    product: {
        category: "COFFEE, TEA & DRINKS", vatIncluded: "incl. VAT", add: "Add", added: "Added",
        favorite: "Add {{name}} to favorites", badgePitango: "PITANGO PRODUCT", badgePopular: "POPULAR",
        detailTitle: "Product details", priceUnavailable: "For prices, contact customer support", bundleOffer: "{{quantity}} for {{price}}", percentOffer: "{{percent}}% off",
        callCustomerSupportForPrices: "Call customer support for prices", notFound: "Product not found"
    },
    cart: {
        title: "Your cart", empty: "Your cart is empty", subtotal: "Subtotal", total: "Total", shipping: "Shipping", shippingFree: "Free",
        checkout: "Continue to Checkout", remove: "Remove {{name}} from cart", addedTitle: "Added to Cart",
        addedMessage: "Your cart has been updated.", viewCart: "View Cart", updateError: "We couldn't update your cart. Please try again.",
        unitPrice: "Regular price: {{price}} each", promotion: "Promotion applied", bundleBreakdown: "Bundle price × {{bundles}} · Promoted items: {{units}}",
        remainderBreakdown: "{{units}} extra item(s) at regular price", discountedUnits: "Discount applied to {{units}} item(s)",
        regularTotal: "Without promotion", youSave: "You save", itemTotal: "Item total",
        addMoreForPromotion: "Add {{units}} more to get the {{offer}} deal.",
        promotionExtraCost: "Only {{amount}} more", promotionLowersTotal: "Your total will be {{amount}} lower",
        addPromotionUnits: "Add {{units}}"
    }
} as const;
